import { getProductData } from "../../utilities";
import ValidateForm from "./validate";
import Variants from "./variants"


const MarkFirstVariant = {

  // função auxiliar para event dispatch
  dispatchChangeEvent: function(input) {
    return new Promise(resolve => {
      const onChange = () => {
        input.removeEventListener("change", onChange);
        resolve(); // Resolve a Promise quando o evento "change" for tratado
      };
      
      input.addEventListener("change", onChange);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  },

  // Valida os inputs do primeiro atributo e marca eles como available/unavailable
  // Por padrão, essa validação em específico não acontece na lógica de prioridade do variants.js
  validateFirstAttrInputs: function(form, variants, attrDisplayOrder) {

    // Busca os inputs da primeira opção visível e permitida para marcação
    let firstInputs = []
    let firstAttrNumber = 0;
    for (let index = 0; index < attrDisplayOrder.length; index++) {
      const attrNumber = attrDisplayOrder[index];

      const inputs = form.querySelectorAll(`[data-attribute="${attrNumber}"] input`)
      if (inputs.length === 0) continue

      firstInputs = inputs
      firstAttrNumber = attrNumber
      break
    }

    if (firstInputs.length === 0) return

    // Procura variantes válidas para cada um dos primeiros atributos
    // para marcar como available e unavailable
    firstInputs.forEach(input => {
      const attrsToMatch = { [`attr${firstAttrNumber}`]: input }
      const label = form.querySelector(`[data-attribute-value="${input.value}"]`)
      const validVariants = variants.filter(variant => {
        const matchedVariant = Variants.matchVariant(variant, attrsToMatch)
        if (matchedVariant && variant.available && variant.stock > 0) {
          return variant
        }
      })

      // Marca a label do input com base na disponibilidade das variantes
      label.classList.remove('-available')
      label.classList.remove('-unavailable')
      label.classList.remove('-disabled')

      if (validVariants.length === 0) {
        label.classList.add('-unavailable')
      } else {
        label.classList.add('-available')
      }
    })

  },

  // Seleciona os inputs que devem ser marcados com base nas configurações
  // do attrMarkFirst e do attrDisplayOrder
  selectFirstInputs: async function(form, attrDisplayOrder, attrMarkFirst) {
    for (let index = 0; index < attrDisplayOrder.length; index++) {
      const inputs = form.querySelectorAll(`[data-attribute="${attrDisplayOrder[index]}"] input`)
      if (inputs.length === 0) continue
  
      const allowMarking = attrMarkFirst[index]
      if (!allowMarking) continue
  
      let foundOneAvailable = false
  
      inputs.forEach(input => { input.checked = false })
  
      for (const input of inputs) {
        const label = form.querySelector(`[data-attribute-value="${input.value}"]`)
        if (label.classList.contains('-available')) {
          input.checked = true
          foundOneAvailable = true
          await MarkFirstVariant.dispatchChangeEvent(input)
          break;
        }
      }
  
      if (foundOneAvailable) continue
  
      inputs[0].checked = true
      await MarkFirstVariant.dispatchChangeEvent(inputs[0])
    }
  },

  // Lida com a marcação da variante mais barata, se esta configuração foi feita no globals.js
  handleFirstCheaper: async function(form, variants, attrDisplayOrder, attrMarkFirst) {

    let variant = variants[0]

    // Procura a variante mais barata e disponível
    for (const v of variants) {
      if (!v.available || !v.stock > 0) continue

      if (v.sale_price <= variant.sale_price) {
        variant = v
      }
    }

    // Encontra os inputs da variante, em ordem de exibição, e marca como checked
    for (let index = 0; index < attrDisplayOrder.length; index++) {
      const attrNumber = attrDisplayOrder[index]
      const variantValue = variant.properties[`property${attrNumber}`].value
      const inputs = form.querySelectorAll(`[data-attribute="${attrNumber}"] input`)
      if (inputs.length === 0) continue
  
      const allowMarking = attrMarkFirst[index]
      if (!allowMarking) continue
  
      inputs.forEach(input => { input.checked = false })
  
      for (const input of inputs) {
        if (input.value === variantValue) {
          input.checked = true
          await MarkFirstVariant.dispatchChangeEvent(input)
          break;
        }
      }
    }
  },

  init: async function(form, attrDisplayOrder, attrMarkFirst, markDefaultCheaper) {
    if (!Array.isArray(attrMarkFirst)) return

    const id = form.getAttribute('data-product-id');
    if (!id) return
    
    const productData = await getProductData(id);
    if (!productData.success) return null

    const { variants } = productData.data
    if (!variants) return

    if (variants.length === 1) {
      ValidateForm.validate(form, variants[0])
    }

    this.validateFirstAttrInputs(form, variants, attrDisplayOrder)

    if (markDefaultCheaper) {
      await this.handleFirstCheaper(form, variants, attrDisplayOrder, attrMarkFirst)
    } else {
      await this.selectFirstInputs(form, attrDisplayOrder, attrMarkFirst)
    }

    if (variants.length === 1) {
      ValidateForm.validate(form, variants[0])
      return variants[0]
    }

    // Retorna false para não interferir com o form.js, onde pega a variante quando é somente 1
    // e executa ações com base nela
    return false
  }
}

export default MarkFirstVariant
